<template>
	<div class="">
    <div class="wpcm-radial-progress-bar" v-show="show_progress">
      <div class="circular" v-if="collected >= 0 && needed">
        <input
          class="knob"
          ref="knob"
          data-fgColor="#d8281b"
          data-bgColor="#dddddd"
          data-thickness=".10"
          readonly
          :value="((collected / needed)*100).toFixed(1)"
        /><span v-if="strings">{{ strings.completed }}</span>
      </div>
    </div>
    <div v-if="show_collection" class="wpcm-amount-collected">
      <span class="amount-return"
        ><i>{{ symbol }}</i> {{ formatNumber(collected) }}</span
      ><span v-if="strings">{{ strings.collection }}</span>
    </div>
    <div class="wpcm-amount-needed" v-if="show_collection">
      <span class="amount-return"
        ><i>{{ symbol }}</i> {{ formatNumber(needed) }}</span
      ><span v-if="strings">{{ strings.target }}</span>
    </div>
    
	</div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useDonationFormsStore } from '../../store';

const store = useDonationFormsStore();
const props = defineProps([
    "strings",
		"show_title",
		"top_title",
		"title",
		"tagline",
		"collected",
		"needed",
		"symbol",
		"show_progress",
		"show_collection",
		"thousand_separator",
		"decimal_separator",
		"number_decimals",
]);
const knob = ref();

const formatNumber = (value: any) => {
  const n = parseFloat(value);
  if (!isFinite(n)) return value;
  const decimals = Math.max(0, parseInt(String(props.number_decimals), 10) || 0);
  const parts = n.toFixed(decimals).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, props.thousand_separator || '');
  return parts.join(props.decimal_separator || '.');
};

const knobInt  = () => {
  if ($.fn.knob !== undefined) {
    $(knob.value).knob();
  }
};

onMounted(() => {
  knobInt();
});


</script>
